export enum KioskMode {
  EventCheckIn = 'event-checkin',
  EventCheckInAndBadgePrinting = 'event-checkin-badge-printing',
  EventCheckOut = 'event-checkout',
  SessionCheckIn = 'session-checkin',
  SessionCheckOut = 'session-checkout',
  BadgePrinting = 'badge-printing',
}
